module.exports = __webpack_public_path__ + "img/pozyczka.dafbdc38.png";